import { Link } from "react-router-dom";
import "./TopPoliticalPartiesSection.css";

const parties = [
  {
    code: "NC",
    name: "नेपाली काँग्रेस",
    color: "#2c9131",
    logo: "https://electionassets.deshsanchar.com/election2079/images/parties/NC.png",
    url: "/candidates/NC?lang=np",
    party_president: "गगन थापा",
  },
  {
    code: "RSP",
    name: "रास्वपा",
    color: "#00aeef",
    logo: "https://electionassets.deshsanchar.com/election2079/images/parties/RSP.png",
    url: "/candidates/RSP?lang=np",
    party_president: "रवि लामिछाने",
  },
  {
    code: "CPNUML",
    name: "नेकपा(एमाले)",
    color: "#e6505b",
    logo: "https://electionassets.deshsanchar.com/election2079/images/parties/CPNUML.png",
    url: "/candidates/CPNUML?lang=np",
    party_president: "खड्ग प्रसाद ओली",
  },
  {
    code: "NDP",
    name: "राप्रपा",
    color: "#e6dc48",
    logo: "https://electionassets.deshsanchar.com/election2079/images/parties/NDP.png",
    url: "/candidates/NDP?lang=np",
    party_president: "राजेन्द्र लिङ्देन"
  },
  
];

const TopPoliticalPartiesSection = () => {
  return (
    <section className="sh-top-parties-section container">
      <div className="sh-top-parties-header">
        <h2 className="sh-top-parties-title">प्रमुख राजनीतिक दलहरू</h2>
        <Link to="/parties?lang=np" className="sh-top-parties-view-all-btn">
          सबै <span className="arrow">→</span>
        </Link>
      </div>

      <div className="sh-top-parties-grid">
        {parties.map((party) => (
          <article key={party.code} className="sh-top-party-card" style={{ "--party-color": party.color }}>
            <div className="sh-top-party-accent" />
            <div className="sh-top-party-content">
              <div className="sh-top-party-logo-wrap">
                <img src={party.logo} alt={party.name} className="sh-top-party-logo" />
              </div>
              <h3 className="sh-top-party-name">{party.name}</h3>
              <p className="sh-top-party-head">पार्टी प्रमुख: {party.party_president}</p>
              <Link to={party.url} className="sh-top-party-btn">
                {party.name}का उम्मेदवारहरू <span className="arrow">→</span>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default TopPoliticalPartiesSection;
